<template>
  <!-- Did not rename the class in edit to not miss up with styling, Cheers :) -->
  <div class="create-campaign-form">
    <div class="mt-5" v-if="renderEditForm && form !== null">
      <form-wizard ref="campaignWizard" color="rgba(var(--vs-primary), 1)" errorColor="rgba(var(--vs-primary), 1)" @on-change="currentTabChanged" :title="null" step-size="sm" :subtitle="null">
        <tab-content :title="$t('Campaign Objective & Type')" class="mb-5" :before-change="resolveStep1">
          <Step1 v-if="currentStep >= 1" v-model="form.step1" :formData="form" ref="step1" :editing="true" />

          <!-- Don't change the MobileWizardButtons hierarchy in the DOM tree -->
          <MobileWizardButtons :isLeadForm="form.step1.objective == 'Lead Form'" :currentStep="currentStep" :editing="true" :canUpdateDetails="canUpdateDetails" />
        </tab-content>

        <tab-content :title="$t('Campaign Details')" class="mb-5" :before-change="resolveStep2">
          <div class="vx-row" v-if="currentStep >= 2">
            <!-- LEFT COL -->
            <div class="vx-col lg:w-3/4 w-full relative">
              <!-- form.step3.adsets.filter(i => i.id > 0) to fetch only the editable adsets -->
              <Step2
                v-model="form.step2"
                ref="step2"
                :serverErrors="errors"
                :editing="true"
                :adsetBudgets="form.step3.adsets.filter(i => i.id > 0).map(i => ({
                  id: i.id,
                  name: i.name,
                  budget: i.budget.budget_value,
                  min_budget: i.budget.cost_per_action,
                }))"
                @adsets-budgets-updated="updateAdsetsBudget"
                @update-campaign-info="updateCampaignInfo"
                :objective="form.step2.objective"
              />

              <!-- Don't change the MobileWizardButtons hierarchy in the DOM tree -->
              <MobileWizardButtons :isLeadForm="form.step1.objective == 'Lead Form'" :currentStep="currentStep" :editing="true" :canUpdateDetails="canUpdateDetails" />
            </div>

            <!-- RIGHT COL -->
            <div class="vx-col lg:w-1/4 w-full">
              <CampaignSummary :form="form" :preview="['summary', 'details', 'adsets' , 'budget']" :currentStep="currentStep" :editing="true" :advertising-channel="form.step1.advertisingChannelObject" />
            </div>
          </div>
        </tab-content>

        <tab-content :title="$t('Ad Set Targeting')" class="mb-5" :before-change="resolveStep3">
          <div class="vx-row" v-if="currentStep >= 3">
            <!-- LEFT COL -->
            <div class="vx-col lg:w-3/4 w-full relative">
              <Step3 v-model="form.step3" ref="step3" :advertising-channel="form.step1.advertisingChannelObject" :objective="form.step1.objective" :type="form.step1.type" :industry_id="form.step2.industry_id" :serverErrors="errors" :editing="true" @passEstimationToRoot="setEstimation" @setActiveAdsetIndex="setActiveAdsetIndex" @adsetCountriesChanged="handleAdsetCountriesChanged" />

              <!-- Don't change the MobileWizardButtons hierarchy in the DOM tree -->
              <MobileWizardButtons :isLeadForm="form.step1.objective == 'Lead Form'" :currentStep="currentStep" :editing="true" :canUpdateDetails="canUpdateDetails" />
            </div>

            <!-- RIGHT COL -->
            <div class="vx-col lg:w-1/4 w-full">
              <CampaignSummary :form="form" :preview="['summary', 'details', 'adsets' , 'budget']" :currentStep="currentStep" :editing="true" :estimation="estimation" :activeAdsetIndex="activeAdsetIndex" :advertising-channel="form.step1.advertisingChannelObject" />
            </div>
          </div>
        </tab-content>

        <tab-content :title="$t('Bidding')" class="mb-5" :before-change="resolveStep4">
          <div class="vx-row" v-if="currentStep >= 4">
            <!-- LEFT COL -->
            <div class="vx-col lg:w-3/4 w-full relative">
              <Step4
                v-model="form.step3"
                ref="step4"
                :advertising-channel="form.step1.advertisingChannelObject"
                :objective="form.step1.objective"
                :main-event="form.step2.main_event"
                :type="form.step1.type"
                :industry="form.step2.industry_id"
                :serverErrors="errors"
                :budgetType="budgetType"
                :editing="true"
                :endDate="form.step2.end_date || ''"
                :startDate="form.step2.start_date || ''"
                :objective-id="form.step1.objective_id"
                :type-id="form.step1.type_id"
                @setActiveAdsetIndex="setActiveAdsetIndex"
                :changedAdsetCountries="changedAdsetCountries"
              />

              <!-- Don't change the MobileWizardButtons hierarchy in the DOM tree -->
              <MobileWizardButtons :isLeadForm="form.step1.objective == 'Lead Form'" :currentStep="currentStep" :editing="true" :canUpdateDetails="canUpdateDetails" />
            </div>

            <!-- RIGHT COL -->
            <div class="vx-col lg:w-1/4 w-full">
              <CampaignSummary :form="form" :preview="['summary', 'details', 'adsets' , 'budget']" :currentStep="currentStep" :activeAdsetIndex="activeAdsetIndex" :editing="true" :advertising-channel="form.step1.advertisingChannelObject"/>
            </div>
          </div>
        </tab-content>

        <tab-content :title="$t('Ads Customization')" class="mb-5" :before-change="resolveStep5">
          <div class="vx-row" v-if="currentStep >= 5">
            <!-- LEFT COL -->
            <div class="vx-col lg:w-3/4 w-full relative">
              <Step5 v-model="form.step3" ref="step5" :advertising-channel="form.step1.advertisingChannelObject" :objective="form.step1.objective" :objective-id="form.step1.objective_id" :type="form.step1.type" :serverErrors="errors" :editing="true" />

              <!-- Don't change the MobileWizardButtons hierarchy in the DOM tree -->
              <MobileWizardButtons :isLeadForm="form.step1.objective == 'Lead Form'" :currentStep="currentStep" :editing="true" :canUpdateDetails="canUpdateDetails" />
            </div>

            <!-- RIGHT COL -->
            <div class="vx-col lg:w-1/4 w-full">
              <CampaignSummary :form="form" :preview="['summary', 'details', 'adsets' , 'budget']" :currentStep="currentStep" :editing="true" :advertising-channel="form.step1.advertisingChannelObject" />
            </div>
          </div>
        </tab-content>

        <!-- lead form new step -->
        <tab-content v-if="form.step1.objective == 'Lead Form'" :title="$t('Lead Form')" class="mb-5" :before-change="resolveStep6">
          <div class="vx-row" v-if="currentStep >= 6">
            <!-- LEFT COL -->
            <div class="vx-col lg:w-3/4 w-full relative p-0">
              <Step6 v-model="form.step6" ref="step6" :serverErrors="errors" :editing="true" />

              <!-- Don't change the MobileWizardButtons hierarchy in the DOM tree -->
              <MobileWizardButtons :isLeadForm="form.step1.objective == 'Lead Form'" :currentStep="currentStep" :editing="true" />
            </div>

            <!-- RIGHT COL -->
            <div class="vx-col lg:w-1/4 w-full">
              <CampaignSummary :form="form" :preview="['summary', 'details', 'adsets' , 'budget']" :currentStep="currentStep" :editing="true" :advertising-channel="form.step1.advertisingChannelObject" />
            </div>
          </div>
        </tab-content>

        <template slot="footer" slot-scope="props">
          <div class="hidden sm:block">
            <!-- desktop -->
            <div class="button-desktop-version">
              <div v-bind:class="{buttonsFullWidth : currentStep === 2}" class="back-button-mobile-version wizard-footer-left">
                <vs-button id="edit-campaign-back-button" v-if="props.activeTabIndex > 0" @click.native="back()" class="update-campaign-back-button back-button-border-radius back-button" color="" type="">
                  <img class="back-button-arrow" src="@/assets/images/campaigns-table-actions/back.svg" alt="">
                  {{ $t('Back') }}
                </vs-button>
              </div>

              <div :class="{'text-center': props.activeTabIndex === 0, 'wizard-footer-left ml-5': props.activeTabIndex > 0 , buttonsFullWidth : currentStep === 2}">
                <vs-button id="edit-campaign-update-button" v-if="canUpdateDetails && currentStep === 2" @click.native="updateCampaignInfo" class="update-campaign-update-button w-40 p-3 button-border-radius shadow-none mr-5" color="primary" type="filled">
                  {{ $t('Update') }}
                </vs-button>

                <vs-button id="edit-campaign-next-button" v-bind:class="{ mainButton: currentStep === 1 || currentStep === 3 || currentStep === 4 || (form.step1.objective === 'Lead Form' && currentStep === 5) , updateCampaignNextButton : currentStep === 2 }" v-if="!props.isLastStep" @click.native="props.nextTab()" class="update-campaign-next-button w-40 p-3 button-border-radius shadow-none" color="" type="">
                  {{ $t('Next') }}
                </vs-button>

                <wizard-button id="edit-campaign-update-adset-button" v-else @click.native="checkDisabledDomains" class="font-light w-40 button-border-radius shadow-none wizard-footer-right finish-button" :style="props.fillButtonStyle">
                  {{ currentStep === 6 ? $t('Update'): $t('Update Adsets') }}
                </wizard-button>
              </div>
            </div>
            <!-- desktop -->
          </div>
        </template>
      </form-wizard>
    </div>

    <speakol-response-popup
      v-on:hide-response-popup="stateModal.show = false"
      :responsePopupData="stateModal"
    />

    <DisallowedDomanisFromPublisherPopup
      :domains="disallowedDomains"
      :show="showDisallowedDomainsPopup"
      @confirm="confirmDisallowedDomains"
      @hide="showDisallowedDomainsPopup=false"
    />
  </div>
</template>


<script>
import DisallowedDomanisFromPublisherPopup from '@/views/campaigns/edit/components/DisallowedDomanisFromPublisherPopup.vue'

import {
  FormWizard,
  WizardButton,
  TabContent
} from 'vue-form-wizard'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import MobileWizardButtons from '@/views/campaigns/components/MobileWizardButtons.vue'

import formatCampaignForForm from '@/views/campaigns/formatCampaignForForm.js'

import CampaignSummary from '@/views/campaigns/components/CampaignSummary.vue'

import {cloneDeep} from 'lodash'

// Steps
import Step1 from '@/views/campaigns/components/steps/Step1.vue'
import Step2 from '@/views/campaigns/components/steps/Step2.vue'
import Step3 from '@/views/campaigns/components/steps/Step3.vue'
import Step4 from '@/views/campaigns/components/steps/Step4.vue'
import Step5 from '@/views/campaigns/components/steps/Step5.vue'
import Step6 from '@/views/campaigns/components/steps/Step6.vue'

import { objectToFormData } from '@/helpers/objectToFormData.js'

export default {
  props: {
    campaign: {
      type: Object
    }
  },
  components: {
    DisallowedDomanisFromPublisherPopup,
    FormWizard,
    WizardButton,
    TabContent,
    CampaignSummary,
    MobileWizardButtons,
    Step1,
    Step2,
    Step3,
    Step4,
    Step5,
    Step6
  },
  data () {
    return {
      // disallowed domains attributes
      showDisallowedDomainsPopup: false,
      disallowedDomainsConfirmed: false,
      disallowedDomains: [],
      /**
       * Key for preventing multi form submitting
       */
      submitting: false,
      isValidating: false,
      originalIndustry: null,
      currentStep: 1,
      form: null,
      renderEditForm: false,
      stateModal: {
        type: 'error',
        show: false,
        body: 'Error message'
      },
      // the budget type of the adsets to be passed to step 4 if the camapign has end date it will hold 'budget' otherwise 'daily_budget'
      budgetType: null,
      adsetBudgets: [],
      estimation: {},
      activeAdsetIndex: 0,
      changedAdsetCountries: {}
    }
  },

  async beforeCreate () {
    await this.$store.dispatch('campaign/getTargetingLookups')
  },

  created () {
    // set the originalIndustry
    this.originalIndustry = this.campaign.campaign_category_id

    this.formatCampaignForEditing(this.campaign)
  },
  watch: {
    redirectStep () {
      this.navigateToTab(this.redirectStep)
    }
  },
  mounted () {
    for (let tabIndex = 0; tabIndex < (this.$route.query.step || 1) - 1; tabIndex++) {
      this.$refs.campaignWizard.activateTab(tabIndex)
    }

    this.navigateToTab(this.$route.query.step || 1)

    this.budgetType = this.form.step2.no_end_date !== 'true' ? 'budget' : 'daily_budget'
  },
  computed: {
    redirectStep () {
      return this.$route.query.step || 1
    },
    // created to check if the industry changed or not
    // if changed the user needs to recheck the bidding
    // https://speakol.atlassian.net/browse/ADREV-808
    canUpdateDetails () {
      return this.form === null ? true : (this.originalIndustry === ((this.form || {}).step2 || {}).industry_id)
    }
  },
  methods: {
    updateAdsetsBudget (adsetBudgets) {
      this.adsetBudgets = adsetBudgets
    },
    formatCampaignForEditing (campaign) {
      this.form = formatCampaignForForm(campaign)

      this.renderEditForm = true
    },
    navigateToTab (tabNumber) {
      const index = tabNumber - 1

      if (index === 0) {
        return
      }

      // this.$refs.campaignWizard.navigateToTab(index)

      this.$refs.campaignWizard.changeTab(0, index) // disables validation
    },
    resolveStep1 () {
      return this.resolveStep()
    },
    resolveStep2 () {
      return this.resolveStep('step2')
    },
    resolveStep3 () {
      return this.resolveStep('step3')
    },
    resolveStep4 () {
      return this.resolveStep('step4')
    },
    resolveStep5 () {
      return this.resolveStep('step5')
    },
    resolveStep6 () {
      return this.resolveStep('step6')
    },
    currentTabChanged (prevIndex, nextIndex) {
      this.currentStep = nextIndex + 1
    },
    resolveNextSuccess () {
      document.getElementById('scrollToTop').click()
    },
    back () {
      this.$refs.campaignWizard.prevTab()
    },
    getFormBasedOnCurrentStep (step) {
      const $form = {}

      if (step === 'step3') {
        $form[step] = {
          advertising_channel_id: this.form.step1.advertisingChannelObject.id,
          adsets: cloneDeep(this.form.step3.adsets).map((adset) => {
            adset.ads = []
            return adset
          })
        }
      } else if (step === 'step4') {
        $form[step] = {
          advertising_channel_id: this.form.step1.advertisingChannelObject.id,
          adsets: cloneDeep(this.form.step3.adsets).map((adset) => {
            adset.ads = []
            adset.industry_id = this.form.step2.industry_id
            return adset
          })
        }
      } else if (step === 'step5') {
        $form[step] = {
          adsets: cloneDeep(this.form.step3.adsets).map((adset) => {
            return {
              ads: adset.ads
            }
          })
        }
      } else {
        $form[step] = this.form[step]
      }

      $form[step].objective = this.form.step1.objective

      $form[step].type = this.form.step1.type

      $form[step].objective_id = this.form.step1.objective_id

      $form[step].type_id = this.form.step1.type_id

      $form[step].start_date = this.form.step2.start_date
      $form[step].end_date = this.form.step2.end_date

      return $form
    },
    /**
     * Resolves the step validation & performs the next action
     */
    resolveStep (stepRef = null) {
      return new Promise(async (resolve, reject) => {
        if (!window.navigator.onLine) {
          reject()
          this.$router.push('/offline')
          return
        }

        // skip some steps due to editing form
        if (stepRef === 'step2' || stepRef === null) {
          // resolve success
          this.resolveNextSuccess()
          resolve(true)
          return
        }

        if (stepRef) {
          const $form = this.getFormBasedOnCurrentStep(stepRef)

          window.axios.post('/campaigns/wizard/partial/submit', objectToFormData($form)).then(() => {
            // clear errors
            this.errors.clear()

            // resolve success
            this.resolveNextSuccess()
            resolve(true)
          }).catch(err => {
            if (err.response && err.response.data) {
              this.$setLaravelValidationErrorsFromResponse(err.response.data)
            }

            reject(err.message)
          })
        } else {
          this.resolveNextSuccess()
          resolve(true)
        }
      })
    },
    async updateCampaign (step = 'step5') {
      this.resolveStep(step)
        .then(async () => {
          if (this.submitting) {
            return
          }

          // start form submitting
          this.submitting = true

          try {
            const request_data = {
              step3: {
                advertising_channel_id: this.form.step1.advertisingChannelObject.id,
                adsets: cloneDeep(this.form.step3).adsets.map((adset) => {
                  adset.industry_id = this.form.step2.industry_id
                  adset.ads = adset.ads.filter(ad => this.isAdUpdateable(ad))
                  return adset
                }),
                objective: this.form.step1.objective,
                type: this.form.step1.type,
                objective_id: this.form.step1.objective_id,
                type_id: this.form.step1.type_id
              },
              _method: 'PATCH'
            }

            if (this.campaign.campaign_category_id !== this.form.step2.industry_id) {
              const step2_data = this.form['step2']
              step2_data.objective = this.form.step1.objective
              step2_data.type = this.form.step1.type
              step2_data.objective_id = this.form.step1.objective_id
              step2_data.type_id = this.form.step1.type_id
              step2_data.adsets_budgets = this.adsetBudgets
              step2_data.start_now = parseInt(this.$route.query.start_now || 0)

              request_data.step2 = step2_data
            }

            const response = await window.axios.post(
              `/campaigns/${this.campaign.id}/update`,
              objectToFormData(request_data)
            )

            this.errors.clear()

            // save initial campaign data
            window.initialCampaignData = JSON.parse(JSON.stringify(response.data.payload))

            if (this.$can('list_all_campaigns')) { // that means this is admin user
              return this.$router.push({
                name: 'campaigns-index-admin'
              })
            }

            this.$router.push({
              name: 'campaigns-success',
              params: {
                id: response.data.payload.id
              },
              query: {
                edit: 1
              }
            }).catch()
          } catch (error) {
            this.submitting = false

            const vErrors = []

            for (const e in error.response.data.errors) {
              if (error.response.data.errors.hasOwnProperty(e)) {
                const element = error.response.data.errors[e]
                element.forEach(err => {
                  vErrors.push(err)
                })
              }
            }

            this.stateModal = {
              type: 'error',
              show: true,
              body: vErrors.join('\n')
            }

            this.$setLaravelValidationErrorsFromResponse(error.response.data)
          }
        })
        .catch(e => {
          console.log(e)
        })
    },
    async updateCampaignInfo (refreshForm = true) {
      try {
        const $form = {}
        $form['step2'] = this.form['step2']
        $form['step2'].objective = this.form.step1.objective
        $form['step2'].type = this.form.step1.type
        $form['step2'].objective_id = this.form.step1.objective_id
        $form['step2'].type_id = this.form.step1.type_id
        $form['step2'].adsets_budgets = this.adsetBudgets
        $form['step'] = 'step2'
        $form['_method'] = 'PATCH'
        $form['start_now'] = parseInt(this.$route.query.start_now || 0)

        const response = await window.axios.post(`/campaigns/${this.campaign.id}/update`, objectToFormData($form))

        // save initial campaign data
        window.initialCampaignData = JSON.parse(JSON.stringify(response.data.payload))

        if (refreshForm) {
          this.formatCampaignForEditing(response.data.payload)

          this.stateModal = {
            type: 'success',
            show: true,
            body: 'Campaign info updated'
          }
        }

        this.budgetType = this.form.step2.no_end_date !== 'true' ? 'budget' : 'daily_budget'
        this.$refs.step2.handleStep2Update()

        this.errors.clear()
      } catch (error) {
        this.$setLaravelValidationErrorsFromResponse(error.response.data)
      }
    },
    isAdUpdateable (ad) {
      if (ad.id === 0) return true

      if (ad.want_to_update) return true

      if (this.$can('review_campaigns')) return true

      // check if the ad status is not hold,  is so will update the ad
      if (ad.acceptance_status !== 2) return true

      return false
    },
    async checkDisabledDomains () {
      if (!this.disallowedDomainsConfirmed) {
        const response = await window.axios.post('/campaigns/checks/domains-disallow-history', {
          campaign_id: this.campaign.id
        })

        if (response.data.payload.domains.length) {
          this.showDisallowedDomainsPopup = true
          this.disallowedDomains = response.data.payload.domains
          return
        }
      }

      await this.updateCampaign(this.currentStep === 6 ? 'step6' : 'step5')
    },
    async confirmDisallowedDomains (purgeableDisallowedDomains) {
      // check: https://speakol.atlassian.net/browse/ADREV-1509
      this.form.step3.adsets.map((adset) => {
        adset.target_platforms.purgeable_disallowed_domains_history = purgeableDisallowedDomains
        return adset
      })

      this.disallowedDomainsConfirmed = true

      this.showDisallowedDomainsPopup = false

      await this.updateCampaign(this.currentStep === 6 ? 'step6' : 'step5')
    },
    setEstimation (estimation) {
      this.estimation = estimation
    },
    setActiveAdsetIndex (activeAdsetIndex) {
      this.activeAdsetIndex = activeAdsetIndex
    },
    handleAdsetCountriesChanged (data) {
      this.changedAdsetCountries = data
    }
  }
}
</script>

<style lang="scss">
  .create-campaign-form {
    .flatpickr-input {
      width: 100%;
    }

    .nav-tabs-navigation {
      margin-top: -14px;
    }

    // campagin details
    .vs-con-input,
    .input-select-con,
    .vue-treeselect {
      margin-top: 10px !important;
    }

    .vs-input--label,
    .vs-select--label,
    .input-label {
      font-weight: normal !important;
      font-size: 16px !important;
    }
    // .input-label {
    //   font-size: 16px !important;
    // }

    .next-button-step-5 {
      background-color: #0092d7;
      color: white;
      border: none;
    }

    .vs-radio--circle {
      box-shadow: none !important;
    }

    // wizard
    .button-border-radius {
      border-radius: 4px !important;
      height: 42px !important;
    }

    .back-button-border-radius {
      border-radius: 4px !important;
      padding: 9px !important;
    }

    .vue-form-wizard.sm .wizard-navigation .wizard-progress-with-circle {
      left: 20px !important;
    }

    .wizard-nav .wizard-icon-circle.checked {
      background-color: rgba(var(--vs-primary), 1) !important;

      .wizard-icon {
        color: white !important;
      }
    }

    .wizard-nav .wizard-icon-container {
      background-color: white !important;

      .wizard-icon {
        color: #378ccb !important;
      }
    }

    .wizard-icon-container {
      border-radius: 100% !important;
    }

    .vue-form-wizard.sm .wizard-nav-pills > li.active > a .wizard-icon {
      color: #ccc !important;
    }

    @media (max-width: 576px) {
      ul.wizard-nav-pills li {
        display: none;
      }

      .wizard-progress-with-circle {
        display: none;
      }

      ul.wizard-nav-pills li.active {
        display: block;
      }

      .buttonsFullWidth {
        width: 100% !important;
        margin-left: 0 !important;

        button {
          width: 100% !important;
        }
      }

      .updateCampaignNextButton {
        margin-top: 20px;
        margin-bottom: 10px;
      }

      // bind class here

      // .wizard-card-footer {
      //   display: flex;
      //   flex-direction: column-reverse;
      // }
      .button-mobile-version {
        display: block !important;
      }

      .button-desktop-version {
        display: none !important;
      }
    }

    .button-mobile-version {
      display: none;
    }

    .button-desktop-version {
      display: block;
    }

    ul.nav-tabs {
      display: inline-flex;
      width: 100% !important;
      overflow-x: scroll;
      overflow-y: hidden;
      position: relative;
      z-index: 1;
    }

    ul.nav-tabs > li > a > div > span {
      text-overflow: ellipsis !important;
      overflow: hidden !important;
      width: 20px !important;
      height: 1.2em !important;
      white-space: nowrap !important;
    }

    .nav-tabs::-webkit-scrollbar-track {
      border-radius: 10px !important;
      background-color: #f5f5f5 !important;
    }

    .nav-tabs::-webkit-scrollbar {
      height: 6px !important;
      background-color: #f5f5f5 !important;
    }

    .nav-tabs::-webkit-scrollbar-thumb {
      border-radius: 10px !important;
      background-color: lightgrey !important;
    }
  }

  .update-campaign-next-button {
    color: rgba(var(--vs-primary), 1);
    border: 1px solid rgba(var(--vs-primary), 1);
  }

  .update-campaign-back-button {
    border: none !important;
    color: #0092d7 !important;
  }

  .wizard-footer-left {
    .vs-button-primary.vs-button-border:hover,
    .vs-button-primary.vs-button-flat:hover {
      background: transparent !important;
    }
  }

  .update-campaign-update-button {
    background: #0092d7 !important;
  }

  .back-button-arrow {
    position: relative;
    top: 2px;
    right: 5px;
  }

  .mainButton {
    color: white;
    background-color: #0092d7;
  }

  .finish-button {
    background-color: #0092d7 !important;
  }

  @media (max-width: 768px) {
  .create-campaign-form ul.nav-tabs {
    display: -webkit-box;
  }
}
</style>
